/**
 * Lightweight cashier welcome / farewell toast without RoleContext → Notification coupling.
 * NotificationSystem (or any host) may listen for 'aman:cashier-greeting'.
 */

export const CASHIER_GREETING_EVENT = 'aman:cashier-greeting';

/**
 * @param {'welcome' | 'farewell' | 'pause' | 'resume'} type
 * @param {{ workerName?: string, language?: string }} [detail]
 */
export function emitCashierGreeting(type, detail = {}) {
  if (typeof window === 'undefined' || !type) return;
  try {
    window.dispatchEvent(
      new CustomEvent(CASHIER_GREETING_EVENT, {
        detail: {
          type,
          workerName: detail.workerName || '',
          language: detail.language || null,
          at: Date.now()
        }
      })
    );
  } catch {
    /* ignore */
  }
}
